import { apiCall, apiCallDownload } from 'providers';
import { MaintenanceValidationHistItem } from '../types';

interface RequestMaintenanceValidationParams {
  device_code: string;
  asset_id: number;
  machine_id: number;
}

interface RequestMaintenanceValidationResult {
  validation_id: number;
}

interface CancelMaintenanceValidationParams {
  validation_id: number;
  device_code: string;
  machine_id: number;
}

interface ActiveMaintenanceValidationResult {
  active: {
    id: number;
    device_code: string;
    start_time: string;
  } | null;
}

export interface MaintenanceValidationHistoryResult {
  list: MaintenanceValidationHistItem[];
  total: number;
}

export async function requestMaintenanceValidation(
  params: RequestMaintenanceValidationParams,
): Promise<RequestMaintenanceValidationResult | undefined> {
  try {
    const response = await apiCall('/maintenance-validation/request', params);
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function cancelMaintenanceValidation(
  params: CancelMaintenanceValidationParams,
): Promise<{ ok: boolean } | undefined> {
  try {
    const response = await apiCall('/maintenance-validation/cancel', params);
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function getActiveMaintenanceValidation(params: {
  device_code: string;
  machine_id: number;
}): Promise<ActiveMaintenanceValidationResult | undefined> {
  try {
    const response = await apiCall('/maintenance-validation/get-active', params);
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function getMaintenanceValidationHistory(params: {
  device_code: string;
  machine_id: number;
  skip?: number;
  limit?: number;
}): Promise<MaintenanceValidationHistoryResult | undefined> {
  try {
    const response = await apiCall('/maintenance-validation/get-history', params);
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export function exportMaintenanceValidationHistory(params: {
  device_code: string;
  machine_id: number;
}) {
  return apiCallDownload('/maintenance-validation/export-history', params);
}
